import { RegisterForm } from '@/features/identity/components/RegisterForm';

export function RegisterPage() {
  return <RegisterForm />;
}
